import { render } from "./UndoRedo.vue?vue&type=template&id=5fccc6b2&scoped=true&ts=true"
import script from "./UndoRedo.vue?vue&type=script&lang=ts"
export * from "./UndoRedo.vue?vue&type=script&lang=ts"

import "./UndoRedo.vue?vue&type=style&index=0&id=5fccc6b2&scoped=true&lang=css"

import exportComponent from "/Users/goodwin/Desktop/Fehrya/Dev_goodwin/tools/easynwk-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fccc6b2"]])

export default __exports__